<template>
  <Dialog
      v-model:visible="visible"
      modal
      :draggable="false"
      :dismissable-mask="true"
      :header="t('CONFIRM_TITLE')"
      class="cancel-training-registration-modal"
  >
    <p>{{ t("SURE_TO_CANCEL") }}</p>

    <template #footer>
      <div class="d-flex justify-content-between w-100">
        <Button :label="t('NO')" severity="secondary" icon="pi pi-times" @click="cancel"/>
        <Button :label="t('YES')" icon="pi pi-check" @click="ok"/>
      </div>
    </template>
  </Dialog>
</template>

<script setup>
import {ref} from "vue";
import {injectAxios} from "@/util/inject";
import {useI18n} from "vue-i18n";
import {useToast} from "@/util/toastUtils";

const {t} = useI18n();
const toast = useToast();
const visible = ref(false);
const axios = injectAxios();
const groupData = ref(null);

const emit = defineEmits(["handleCancel"]);

function showRegistrationCancellationModal(group) {
  groupData.value = group;
  visible.value = true;
}

function cancel() {
  visible.value = false;
}

async function ok(ev) {
  ev.preventDefault();
  await cancelTrainingRegistration();
}

async function cancelTrainingRegistration() {
  await axios.post(`/training/group/${groupData.value.id}/cancel-register`, groupData.value.events);
  emit("handleCancel");
  toast.makeSuccessToast(t("CANCELED"));
  cancel();
}

defineExpose({
  showRegistrationCancellationModal,
});
</script>
